module.exports = __webpack_public_path__ + "img/software_soluno.e8efa4eb.jpg";